import { createFileRoute } from "@tanstack/react-router";
import useFeatureFlag from "@/lib/featureFlags/useFeatureFlags";
import DocumentationLegacy from "@/components/documentation/DocumentationLegacy";
import DocumentationReportsList from "@/components/documentation/DocumentationReportsList";

export const Route = createFileRoute("/dashboard/documentation/")({
    component: RouteComponent,
});

function RouteComponent() {
    const { fieldReportsEnabled } = useFeatureFlag();
    return fieldReportsEnabled ? (
        <DocumentationReportsList />
    ) : (
        <DocumentationLegacy />
    );
}
